import React from 'react';
import Icon from '../../../components/AppIcon';

const TimeEstimateInput = ({ value, onChange, error }) => {
  const handleIncrement = () => {
    onChange(Math.min((value || 0) + 15, 480));
  };

  const handleDecrement = () => {
    onChange(Math.max((value || 0) - 15, 0));
  };

  const formatTime = (minutes) => {
    if (!minutes) return '0m';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours === 0) return `${mins}m`;
    if (mins === 0) return `${hours}h`;
    return `${hours}h ${mins}m`;
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-2 md:gap-3">
        <button
          type="button"
          onClick={handleDecrement}
          disabled={!value || value === 0}
          className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-muted hover:bg-muted/80 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center transition-all duration-250"
          aria-label="Decrease time estimate"
        >
          <Icon name="Minus" size={20} color="currentColor" />
        </button>

        <div className="flex-1 h-10 md:h-12 rounded-lg bg-input border border-border px-3 md:px-4 flex items-center justify-center">
          <span className="text-base md:text-lg font-medium text-foreground data-text">
            {formatTime(value || 0)}
          </span>
        </div>

        <button
          type="button"
          onClick={handleIncrement}
          disabled={value >= 480}
          className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-muted hover:bg-muted/80 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center transition-all duration-250"
          aria-label="Increase time estimate"
        >
          <Icon name="Plus" size={20} color="currentColor" />
        </button>
      </div>
      {error && (
        <p className="text-xs md:text-sm text-error mt-1.5" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default TimeEstimateInput;